import React from "react";
import styles from "./index.module.less";

/** 对齐 spikex-ai-web app/(site)/layout.tsx — 固定右上 brand radial */
export default function SpikexPcBackdrop() {
  return (
    <div className={styles.pcBackdrop} aria-hidden="true">
      <div className={styles.pcBackdropTopRight} />
    </div>
  );
}
